<div class="layout-menu flex flex-col justify-between">
  <ul class="sidebar-menu-items">
    <ng-container *ngFor="let item of model; let i = index">
      <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
      <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
  </ul>
  <div class="my-4">
    <app-profile-section></app-profile-section>
  </div>
</div>